var _style, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLoungeAccess = function SvgLoungeAccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "lounge-access_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".lounge-access_svg__st0{fill:#03d47c}.lounge-access_svg__st1{fill:#fee45e}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "lounge-access_svg__st0",
    d: "M11 24v-2c0-1.1.9-2 2-2s2 .9 2 2c0 .6.4 1 1 1h8c.6 0 1-.4 1-1 0-1.1.9-2 2-2s2 .9 2 2v2c0 .4-.1.8-.3 1.1-.6.9-1.7 1.8-1.7 2.9h-2v-2H15v2h-2c0-1.1-1.1-2-1.7-2.9-.2-.3-.3-.7-.3-1.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "lounge-access_svg__st1",
    d: "M31 9.8c-.1-.2-.2-.4-.5-.4h-2.1l-.8-2c-.2-.4-.5-.4-.6-.4-.1 0-.4 0-.6.4l-.8 1.9h-2.1c-.4 0-.5.4-.5.4 0 .1-.1.4.1.6l1.6 1.8-.6 1.9c-.1.3.1.5.2.7.1 0 .3.2.7.1l2-1.1 2 1.2c.3.2.6 0 .7-.1.1-.1.3-.3.2-.7l-.6-2 1.5-1.7c.2-.1.2-.4.2-.6zM28.5 7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "lounge-access_svg__st0",
    d: "M23.1 16.3c-.8-.6-1.2-1.7-1-2.7v-.1l.2-.5H16c-1.1 0-2 .9-2 2v3h.6c1.3 0 2.4 1.1 2.4 2.4 0 .3.3.6.6.6h4.8c.3 0 .6-.3.6-.6 0-1.3 1.1-2.4 2.4-2.4h.6v-1.4c-.9.5-2 .4-2.9-.3z"
  })));
};
export default SvgLoungeAccess;